import { render, staticRenderFns } from "./DashboardGenericNotification.vue?vue&type=template&id=25a7803d&scoped=true&"
import script from "./DashboardGenericNotification.vue?vue&type=script&lang=js&"
export * from "./DashboardGenericNotification.vue?vue&type=script&lang=js&"
import style0 from "./DashboardGenericNotification.vue?vue&type=style&index=0&id=25a7803d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a7803d",
  null
  
)

export default component.exports